import _isEmpty from 'lodash/isEmpty';
import _isFinite from 'lodash/isFinite';
import _isNumber from 'lodash/isNumber';

var isEmpty = function isEmpty(value) {
  if (_isNumber(value)) {
    return !_isFinite(value); // if finite, return false. Covers NaN
  }

  return _isEmpty(value);
};

export { isEmpty };